/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { useCallback } from "react";
import { Flex, Typography } from "../..";
import { selectTagCSS } from "./SelectTheme.css";

export const SelectTags = ({
  tags,
  setValues,
}: {
  tags: string[];
  setValues?: (values: string[]) => void;
}) => {
  const onClickTag = useCallback(
    (tag: string) => {
      const tempTags = [...tags];
      const index = tempTags.findIndex((_tag) => _tag === tag);

      tempTags.splice(index, 1);

      setValues?.(tempTags);
    },
    [setValues, tags],
  );

  return (
    <Flex
      gap={vars.spacing[1]}
      overflowX="scroll"
      sx={{
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {tags.map((tag) => (
        <RemovableTag key={tag} tag={tag} onClick={onClickTag} />
      ))}
    </Flex>
  );
};

const RemovableTag = ({ tag, onClick }: { tag: string; onClick: (value: string) => void }) => {
  return (
    <Flex
      css={selectTagCSS}
      native={{
        onClick: (event) => {
          event.stopPropagation();
          onClick(tag);
        },
      }}
    >
      <Typography variant="label-small" colorToken="textSub">
        {tag}
      </Typography>

      {/* X (icon) */}
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="clay-tag-button"
        color={vars.semantic.color.iconSub}
      >
        <path
          d="M17 7L7 17M7 7L17 17"
          stroke="currentColor"
          strokeWidth="1.2"
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Flex>
  );
};
